export enum ETipoControleSerie {
    SerieNFe = 1,
    SerieNFCe = 2,
    SerieMDFe = 3,
    SerieNFSe = 4,
}
